import cleanDeep from 'clean-deep';
import _ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { Types } from "../actions/documentActions";
import { NotificationManager } from "react-notifications";

//import { v4 as uuidv4 } from 'uuid';

const documentReducers = (state, action) => {
    switch (action.type) {
        case Types.DOCUMENT_GET_LIST: {
            let newState = _.cloneDeep(state);
            newState.documents.rows = action.documents;
            newState.documents.loading = false;
            return newState;
        }
        case Types.DOCUMENT_GETTING_LIST: {
            let newState = _.cloneDeep(state);
            newState.documents.loading = true;
            return newState;
        }
        case Types.DOCUMENT_DOWNLOAD: {
            let newState = _.cloneDeep(state);
            newState.documents.downloading = newState.documents.downloading || {};
            newState.documents.downloading[action.id] = true;
            return newState;
        }

        case Types.DOCUMENT_DOWNLOADED: {
            let newState = _.cloneDeep(state);
            newState.documents.downloading = newState.documents.downloading || {};
            delete newState.documents.downloading[action.id];

            const document = state.documents.rows.find((doc) => doc.id == action.id);

            const url = action.payload.signedURL ?? action.payload.url;

            if (url) {
                const popup = window.open(url);
                if (!popup || popup.closed || typeof popup.closed == 'undefined') {
                    //Worked For IE and Firefox
                    alert("Popup Blocker is enabled! Please add this site to your exception list.");
                }
            }

            NotificationManager.success(`${document.name} downloaded`, "Success");
            return newState;
        }

        case Types.DOCUMENT_DOWNLOAD_FAILED: {
            let newState = _.cloneDeep(state);
            delete newState.documents.downloading[action.id];
            const document = state.documents.rows.find((doc) => doc.id == action.id);
            NotificationManager.error(`${document.name} download failed`, "Error");
            return newState;
        }

        case Types.DOCUMENT_EMAIL_SENDING: {
            let newState = _.cloneDeep(state);
            newState.documents.sending = newState.documents.sending || {};
            newState.documents.sending[action.id] = true;
            return newState;
        }
        case Types.DOCUMENT_EMAIL_SENT: {
            let newState = _.cloneDeep(state);
            delete newState.documents.sending[action.id];

            const document = state.documents.rows.find((doc) => doc.id === action.id);
            NotificationManager.success(`${document.name} email sent`, "Success");
            return newState;
        }
        case Types.DOCUMENT_EMAIL_FAILED: {
            let newState = _.cloneDeep(state);
            delete newState.documents.sending[action.id];
            const document = state.documents.rows.find((doc) => doc.id === action.id);
            NotificationManager.error(`${document.name} email failed. Confirm the employee has a valid email address`, "Error");
            return newState;
        }

        default:
            return state
}
};

export default documentReducers;